import { computed } from 'vue';
import {
  ChargingStation as ChargingStationApi,
  searchChargingStations
} from '@infuse/api/e-connector/charging-station';
import { mapToDomain } from '@infuse/e-connector/charging-station/domain';
import { usePageableResource } from '@infuse/e-connector/shared/queries';

export const useChargingStations = (pageSize = 20) => {
  const query = usePageableResource<ChargingStationApi>(searchChargingStations, {
    queryKey: 'charging-stations',
    searchableFields: ['name'],
    pageSize
  });

  const chargingStations = computed(
    () => query.data.value?.pages.flatMap((page) => page.content?.map((cs) => mapToDomain(cs))) || []
  );

  return {
    ...query,
    chargingStations
  };
};
